import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { lookbookCollections } from '../data/lookbookData';
export function Lookbook() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-383">
      <div className="max-w-[1800px] mx-auto" data-id="element-384">
        <header className="mb-20 text-center" data-id="element-385">
          <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-386">
            Editorial
          </span>
          <h1 className="text-4xl md:text-6xl font-display font-bold tracking-[0.2em] uppercase mb-6" data-id="element-387">
            The Lookbook
          </h1>
          <p className="max-w-xl mx-auto text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-388">
            Explore the movement, texture, and cultural narrative of Djili
            Creations. Click a model to view the full editorial.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1" data-id="element-389">
          {lookbookCollections.map((collection, idx) => <Link to={`/lookbook/${collection.id}`} key={collection.id} data-id="element-390">
              <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: idx * 0.1
          }} className="relative aspect-[3/4] group cursor-pointer overflow-hidden bg-grey-divider" data-id="element-391">
                <img src={collection.image} alt={collection.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" data-id="element-392" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-500" data-id="element-393" />

                <div className="absolute top-6 left-6 text-white" data-id="element-394">
                  <span className="text-[9px] font-display tracking-[0.3em] uppercase opacity-70" data-id="element-395">
                    Featuring
                  </span>
                  <p className="text-[10px] font-display font-bold tracking-widest uppercase" data-id="element-396">
                    {collection.model}
                  </p>
                </div>

                <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-8 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-397">
                  <h3 className="text-xl font-display font-bold tracking-widest uppercase mb-4" data-id="element-398">
                    {collection.title}
                  </h3>
                  <div className="w-12 h-[1px] bg-white mb-4" data-id="element-399" />
                  <span className="text-[10px] font-display tracking-[0.3em] uppercase" data-id="element-400">
                    View Editorial
                  </span>
                </div>

                <div className="absolute bottom-6 left-6 right-6 flex justify-between items-end opacity-100 group-hover:opacity-0 transition-opacity duration-500" data-id="element-401">
                  <h3 className="text-white text-lg font-display font-bold tracking-widest uppercase drop-shadow-lg" data-id="element-402">
                    {collection.title}
                  </h3>
                  <span className="text-white text-[9px] font-display tracking-widest uppercase drop-shadow-lg" data-id="element-403">
                    {String(idx + 1).padStart(2, '0')} /{' '}
                    {String(lookbookCollections.length).padStart(2, '0')}
                  </span>
                </div>
              </motion.div>
            </Link>)}
        </div>
      </div>
    </div>;
}